var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSublocationsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0697 19.59L4.33969 2.85999L2.92969 4.26999L4.87969 6.21999C3.75969 7.39999 2.99969 9.04999 2.99969 11.15C2.99969 14.27 5.32969 17.56 9.99969 21C10.7297 20.46 11.3797 19.93 11.9997 19.4C12.6197 19.93 13.2697 20.46 13.9997 21C15.1797 20.13 16.1897 19.27 17.0697 18.41L19.6597 21L21.0697 19.59ZM9.99969 18.47C6.71969 15.82 4.99969 13.3 4.99969 11.15C4.99969 9.58999 5.53969 8.44999 6.29969 7.63999L7.37969 8.71999C7.13969 9.44999 6.99969 10.26 6.99969 11.15C6.99969 13.36 8.18969 15.65 10.5297 18.02C10.3497 18.17 10.1897 18.32 9.99969 18.47ZM8.99969 11.15C8.99969 10.88 9.01969 10.63 9.04969 10.39L15.6697 17.01C15.1697 17.49 14.6097 17.98 13.9997 18.47C10.7197 15.82 8.99969 13.3 8.99969 11.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.00003C15.93 6.00003 19 7.40003 19 11.15C19 12.01 18.72 12.92 18.19 13.88L19.65 15.34C20.54 13.92 21.01 12.52 21.01 11.16C21.01 6.47003 17.28 4.01003 14.01 4.01003C12.56 4.01003 11.02 4.50003 9.75 5.44003L11.19 6.88003C12.11 6.27003 13.17 6.01003 14.01 6.01003L14 6.00003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSublocationsInactive);
export default __webpack_public_path__ + "static/media/icon-sublocations-inactive.fc65da0c94a8fbcb1b818068410a20c9.svg";
export { ForwardRef as ReactComponent };